import React, { useEffect, useState } from "react";
import logo from "../../assets/images/logo/app-logo.svg";
import Button from "../../components/global/button/Button";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import "../payment/css/payment-modal.scss";
import {
  AddPaymentService,
  getClientAvailableBalance,
} from "../../services/api_services/PaymentService";
import SuccessResponseTickAnimation from "../../components/dashboard/SuccessResponseTickAnimation";
import GlobalData from "../../utils/GlobalData";
import moment from "moment";
import { toast } from "react-toastify";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import {
  EnhancedTableHead,
  getComparator,
  stableSort,
} from "../../components/dashboard/table_component/TableComponent";
import ConfirmationModal from "../ConfirmationModal";

export default function AddPaymentModal(props) {
  var tempCurrentDate;

  const [headCells] = useState([
    {
      id: "checkBox",
      numeric: false,
      disablePadding: false,
      label: "",
      disableSorting: true,
    },
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "Invoice Number",
      disableSorting: true,
    },
    {
      id: "total",
      numeric: false,
      disablePadding: false,
      label: "Total",
      disableSorting: true,
    },
    {
      id: "balance",
      numeric: false,
      disablePadding: false,
      label: "Balance",
      disableSorting: true,
    },
  ]);

  const [todaysDate] = useState(new Date().getTime());
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [isSuccessfulPayment, setIsSuccessfulPayment] = useState(false);
  const [payableAmount, setPayableAmount] = useState("");
  const [paymentMessage, setPaymentMessage] = useState("");
  const [isUseAvailableBalance, setIsUseAvailableBalance] = useState(false);
  const [availableBalance, setAvailableBalance] = useState();
  const [isAddPaymentApiLoading, setIsAddPaymentApiLoading] = useState(false);
  const [pendingInvoiceList, setPendingInvoiceList] = useState([]);
  const [paymentDate, setPaymentDate] = useState(todaysDate);
  const [dueAmount, setDueAmount] = useState("");
  const [selectedPendingInvoiceList, setSelectedPendingInvoiceList] = useState(
    []
  );
  const [selectedPendingInvoiceCost, setSelectedPendingInvoiceCost] =
    useState(0);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);

  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [remainingAvailableBalance, setRemainingAvailableBalance] = useState();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");

  const [confirmationModal, setConfirmationModal] = useState(false);

  useEffect(() => {
    currentDate();
    if (props.show) {
      getClientBalance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  useEffect(() => {
    setDueAmount(props.Invoice.balance ?? "");
    setPendingInvoiceList(
      props.Invoice?.pendingPaymentInvoiceList != null
        ? props.Invoice?.pendingPaymentInvoiceList
        : []
    );
  }, [props.Invoice.balance, props.show, props.Invoice]);

  useEffect(() => {
    let pendingInvoiceCost = 0;

    setDueAmount(props.Invoice.balance ?? "");
    setRemainingAvailableBalance(availableBalance);

    selectedPendingInvoiceList.forEach((item) => {
      pendingInvoiceCost += item.balance;
    });

    setSelectedPendingInvoiceCost(pendingInvoiceCost);
    setTotalPendingAmount(pendingInvoiceCost);
    setPendingInvoices([]);

    const pendingInvoices = selectedPendingInvoiceList.map((item) => {
      return {
        amount: item.balance,
        clientId: props.Invoice.clientId,
        clientName: props.Invoice.name,
        id: 0,
        invoiceId: item.id,
        paymentDate: paymentDate,
        paymentType: paymentMode,
        status: "Done",
        isUseCreditWallet: false,
      };
    });

    if (
      pendingInvoices &&
      pendingInvoices.length > 0 &&
      availableBalance > 0 &&
      isUseAvailableBalance
    ) {
      const updatedPendingInvoices = processInvoices(
        pendingInvoices,
        availableBalance,pendingInvoiceCost
      );
      setPendingInvoices(updatedPendingInvoices);
    } else {
      if (isUseAvailableBalance && availableBalance > 0) {
        if (props.Invoice.balance > availableBalance) {
          setDueAmount(props.Invoice.balance - availableBalance);
        } else {
          setDueAmount(0);
        }
      } else {
        setDueAmount(props.Invoice.balance);
      }

      setPendingInvoices(pendingInvoices);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPendingInvoiceList, isUseAvailableBalance]);

  const processInvoices = (invoices, creditBalance,pendingInvoiceCost) => {
    const result = [];
    let updatedSelectedInvoiceCost = pendingInvoiceCost;
    let updatedCreditBalance = creditBalance;

    invoices.forEach((invoice) => {
      const invoiceBalance = invoice.amount;

      if (updatedCreditBalance > invoiceBalance) {
        result.push({
          ...invoice,
          isUseCreditWallet: true,
          amount: invoiceBalance,
          paymentType: "Credit Wallet",
        });

        updatedCreditBalance = updatedCreditBalance - invoiceBalance;

        if (updatedSelectedInvoiceCost > invoiceBalance) {
          updatedSelectedInvoiceCost =
          updatedSelectedInvoiceCost - invoiceBalance;
        } else if (updatedSelectedInvoiceCost > 0) {
          updatedSelectedInvoiceCost =
            invoiceBalance - updatedSelectedInvoiceCost;
          setSelectedPendingInvoiceCost(
            invoiceBalance - updatedSelectedInvoiceCost
          );
        }

        setSelectedPendingInvoiceCost(updatedSelectedInvoiceCost);
        setRemainingAvailableBalance(updatedCreditBalance);
      } else if (updatedCreditBalance > 0) {
        result.push({
          ...invoice,
          isUseCreditWallet: true,
          amount: updatedCreditBalance,
          paymentType: "Credit Wallet",
        });

        const remainingBalance = invoiceBalance - updatedCreditBalance;
        updatedSelectedInvoiceCost = remainingBalance;
        updatedCreditBalance = updatedCreditBalance - updatedCreditBalance;

        if (remainingBalance > 0) {
          result.push({
            ...invoice,
            isUseCreditWallet: false,
            amount: remainingBalance,
          });
        }
      } else {
        updatedSelectedInvoiceCost =
          updatedSelectedInvoiceCost + invoiceBalance;
        result.push(invoice);
      }
      setSelectedPendingInvoiceCost(updatedSelectedInvoiceCost);
      setRemainingAvailableBalance(updatedCreditBalance);
    });

    if (isUseAvailableBalance && updatedCreditBalance > 0) {
      if (props.Invoice.balance > updatedCreditBalance) {
        setDueAmount(props.Invoice.balance - updatedCreditBalance);
      } else {
        setDueAmount(0);
      }
    } else {
      setDueAmount(props.Invoice.balance);
    }
    return result;
  };

  useEffect(() => {
    if (payableAmount === "") {
      setPaymentMessage("");
      return;
    }

    if (payableAmount < selectedPendingInvoiceCost) {
      setPaymentMessage(
        "You can't enter amount less than selected pending invoice amount "
      );
    } else if (payableAmount - selectedPendingInvoiceCost > dueAmount) {
      setPaymentMessage(
        "You have entered an excess amount, which will be credited toward future payments."
      );
    } else if (
      payableAmount < dueAmount + selectedPendingInvoiceCost &&
      payableAmount >= 0
    ) {
      setPaymentMessage(
        "You have entered a lesser amount, you can pay the remaining amount again."
      );
    } else {
      setPaymentMessage("");
    }
  }, [payableAmount, dueAmount, selectedPendingInvoiceCost]);

  async function getClientBalance() {
    if (props?.Invoice?.clientId) {
      const response = await getClientAvailableBalance(
        props?.Invoice?.clientId
      );
      setAvailableBalance(response.data.totalCreditBalance ?? 0);
      setRemainingAvailableBalance(response.data.totalCreditBalance ?? 0);
    }
  }

  function handleSubmit() {
    props.onHide();
    props.goToPaymentTab();
  }

  function handleSelect(e) {
    setPaymentMode(e.target.value);
  }

  function handleRequestSort(event, property) {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  }

  const handleCheckBox = (invoice, e) => {
    const checked = e.target.checked;

    let selectedPendingInvoices = [...selectedPendingInvoiceList];

    if (checked) {
      selectedPendingInvoices.push(invoice);
    } else {
      selectedPendingInvoices = selectedPendingInvoiceList.filter(
        (item) => item.id !== invoice.id
      );
    }

    setSelectedPendingInvoiceList(selectedPendingInvoices);
  };

  async function addPaymentHandler() {
    if (
      !paymentDate ||
      moment(paymentDate).format("YYYY-MM-DD") <
        moment(props?.appointmentInfo?.visitDate?props?.appointmentInfo?.visitDate:props.Invoice?.createDate?props.Invoice?.createDate:undefined).format("YYYY-MM-DD") ||
      paymentDate === 0
    ) {
      toast.warning("Payment date is invalid!");
      return true;
    }

    if (
      selectedPendingInvoiceCost > 0 &&
      selectedPendingInvoiceList &&
      selectedPendingInvoiceList.length > 0 &&
      (payableAmount < selectedPendingInvoiceCost)
    ) {
      toast.warning(
        "Please enter amount greater than Selected Pending Invoice Amount " +
          selectedPendingInvoiceCost
      );

      return true;
    }
    setIsAddPaymentApiLoading(true);

    let hold = [];

    if (isUseAvailableBalance) {
      if (payableAmount > selectedPendingInvoiceCost) {
        const reqBodyWithoutBalance = {
          amount: +payableAmount - selectedPendingInvoiceCost,
          clientId: props.Invoice.clientId,
          clientName: props.Invoice.name,
          id: 0,
          invoiceId: props.Invoice.id,
          paymentDate: paymentDate,
          paymentType: paymentMode,
          status: "Done",
          isUseCreditWallet: false,
        };

        const reqBodyWithBalance = {
          amount:
            dueAmount === 0 ? props.Invoice.balance : remainingAvailableBalance,
          clientId: props.Invoice.clientId,
          clientName: props.Invoice.name,
          id: 0,
          invoiceId: props.Invoice.id,
          paymentDate: paymentDate,
          paymentType: "Credit Wallet",
          status: "Done",
          isUseCreditWallet: isUseAvailableBalance,
        };

        hold = [reqBodyWithBalance, reqBodyWithoutBalance];
      } else {
        const reqBodyWithoutBalance = {
          amount: +payableAmount - selectedPendingInvoiceCost,
          clientId: props.Invoice.clientId,
          clientName: props.Invoice.name,
          id: 0,
          invoiceId: props.Invoice.id,
          paymentDate: paymentDate,
          paymentType: paymentMode,
          status: "Done",
          isUseCreditWallet: false,
        };

        const reqBodyWithBalance = {
          amount:
            dueAmount === 0 ? props.Invoice.balance : remainingAvailableBalance,
          clientId: props.Invoice.clientId,
          clientName: props.Invoice.name,
          id: 0,
          invoiceId: props.Invoice.id,
          paymentDate: paymentDate,
          paymentType: "Credit Wallet",
          status: "Done",
          isUseCreditWallet: isUseAvailableBalance,
        };

        hold = [reqBodyWithBalance, reqBodyWithoutBalance];
      }
    } else {
      const reqBody = {
        amount:
          payableAmount === ""
            ? dueAmount
            : +payableAmount - selectedPendingInvoiceCost,
        clientId: props.Invoice.clientId,
        clientName: props.Invoice.name,
        id: 0,
        invoiceId: props.Invoice.id,
        paymentDate: paymentDate,
        paymentType: paymentMode,
        status: "Done",
        isUseCreditWallet: isUseAvailableBalance,
      };

      hold = [reqBody];
    }

    const updatedPendingInvoices = pendingInvoices.map((item)=>{
      if(item.paymentType==="Credit Wallet")
      {
        return item;
      }else{
        return {
          ...item,
          paymentType :paymentMode
        }
      }
    })

    hold = [...hold, ...updatedPendingInvoices];

    const response = await AddPaymentService(hold);
    setIsAddPaymentApiLoading(false);
    if (response) {
      setIsSuccessfulPayment(!isSuccessfulPayment);
      setIsUseAvailableBalance(false);
      setPendingInvoiceList([]);
      setSelectedPendingInvoiceCost(0);
      setSelectedPendingInvoiceList([]);
      setTotalPendingAmount(0);
      setPendingInvoices([]);
      setRemainingAvailableBalance(0);
      if (selectedPendingInvoiceList && selectedPendingInvoiceList.length > 0) {
        toggleConfirmationModal();
      }
    }
  }

  function currentDate() {
    var date = new Date();
    tempCurrentDate = date.getTime();
    setPaymentDate(tempCurrentDate);
  }

  function toggleConfirmationModal() {
    setConfirmationModal(!confirmationModal);
  }

  return (
    <Modal
      size="md"
      centered
      show={props.show}
      // onHide={props.onHide}
      dialogClassName="Payment-modal"
    >
      <ModalHeader className="justify-content-center">
        {isSuccessfulPayment ? (
          <div className="text-center">
            <img src={logo} alt="" height="30" />
          </div>
        ) : (
          <>
            <div className="text-center">
              <img src={logo} alt="" height="30" />

              <h6 className="mt-2 text-center">Pay Fees</h6>
              <h6 className="mt-2 txt-secondary text-center">
                Complete your payment
              </h6>
            </div>
          </>
        )}
      </ModalHeader>
      <ModalBody>
        {isSuccessfulPayment ? (
          <div className="d-flex flex-column align-items-center text-center paySuccessWrapper mt-4">
            <SuccessResponseTickAnimation
              isSuccessTick={isSuccessfulPayment}
              setSuccessTick={setIsSuccessfulPayment}
              isKeepElement={true}
            />
            <span className="payAmount txt-warning">
              ₹ {parseFloat(+payableAmount).toFixed(2)}
            </span>
            <h4 className="txt-success payLabel">Payment Successful!</h4>{" "}
          </div>
        ) : (
          <div className="mt-2 justify-content-end">
            <div className="d-flex justify-content-between flex-wrap ">
              <label className="dateLabel mb-2">Payment Date : </label>
              <div className="full-width">
                <input
                  type="date"
                  className="form-control"
                  name="paymentDate"
                  min={moment(props?.appointmentInfo?.visitDate?props?.appointmentInfo?.visitDate:props.Invoice?.createDate?props.Invoice?.createDate:undefined).format(
                    "YYYY-MM-DD"
                  )}
                  defaultValue={moment(todaysDate).format("YYYY-MM-DD")}
                  onChange={(e) => {
                    let paymentDate = new Date(e.target.value).getTime();
                    setPaymentDate(
                      isNaN(paymentDate) ? undefined : paymentDate
                    );
                  }}
                />
              </div>
            </div>

            <h5 className="mt-3 total-amount txt-primary">
              <span>Total Amount :</span>
              <span className="float-end">
                ₹{" "}
                {parseFloat(props.Invoice.balance + totalPendingAmount).toFixed(
                  2
                )}
              </span>
            </h5>
            <p className="m-2 ">
              <span>Credit Wallet Balance :</span>
              <span className="float-end txt-success">
                ₹ {parseFloat(availableBalance).toFixed(2)}
              </span>
            </p>

            <div className="d-flex gap-1 mx-2">
              <input
                className="form-check-input"
                name="consumePackage"
                type="checkbox"
                checked={isUseAvailableBalance}
                disabled={!availableBalance}
                onChange={(e) => {
                  setIsUseAvailableBalance(e.target.checked);
                }}
              />
              <p className="m-0">Use credit wallet balance</p>
            </div>

            {pendingInvoiceList && pendingInvoiceList.length > 0 && (
              <div className="d-flex justify-content-between align-items-center m-2">
                <label>
                  <span>Selected Pending Invoice Amount :</span>
                </label>

                <span className="txt-error">
                  ₹ {parseFloat(selectedPendingInvoiceCost).toFixed(2)}
                </span>
              </div>
            )}

            {pendingInvoiceList && pendingInvoiceList.length > 0 && (
              <div className="d-flex justify-content-between align-items-center m-2">
                <label>
                  <span>Current Invoice Amount :</span>
                </label>

                <span className="txt-error">
                  ₹ {parseFloat(dueAmount).toFixed(2)}
                </span>
              </div>
            )}

            <div className="d-flex justify-content-between align-items-center m-2">
              <label>
                <span>Total Amount Due :</span>
              </label>

              <span className="txt-error">
                ₹{" "}
                {parseFloat(dueAmount + selectedPendingInvoiceCost).toFixed(2)}
              </span>
            </div>

            <div className="d-flex justify-content-between align-items-center mx-2 mb-3">
              <label>
                <span>Amount Paid :</span>
              </label>

              <div style={{ width: "30%", height: "40px" }}>
                <input
                  className={`form-control `}
                  type="number"
                  id="payAmount"
                  name="payAmount"
                  placeholder="Enter Amount"
                  value={payableAmount}
                  onChange={(e) => {
                    if (e.target.value >= 0) {
                      setPayableAmount(e.target.value);
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                  required
                />
              </div>
            </div>

            {paymentMessage && (
              <p
                className="txt-error mb-2"
                style={{
                  fontWeight: "300",
                  fontSize: "15px",
                  lineHeight: "16px",
                  margin: "5px 0px 10px 0px",
                }}
              >
                {paymentMessage}
              </p>
            )}

            {pendingInvoiceList && pendingInvoiceList.length > 0 && (
              <div
                className={
                  pendingInvoiceList.length !== 0 ? "overflowY-scroll" : ""
                }
                style={{
                  maxHeight: "250px",
                  overflowY: "auto",
                }}
              >
              <label className="dateLabel mb-2">Pending Invoices : </label>
                <TableContainer id="tableDiv ">
                  <Table className="tableX" aria-labelledby="tableTitle mt-3">
                    <EnhancedTableHead
                      order={order}
                      orderBy={orderBy}
                      onRequestSort={handleRequestSort}
                      rowCount={pendingInvoiceList.length}
                      headCells={headCells}
                    />
                    <TableBody className="table">
                      {stableSort(
                        pendingInvoiceList,
                        getComparator(order, orderBy)
                      ).map((row) => {
                        return (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={"Appointment-" + row.id}
                            style={{ backgroundColor: row.colorCode }}
                          >
                            <TableCell data-cell={headCells[1].label}>
                              <input
                                type="checkbox"
                                onChange={(e) => handleCheckBox(row, e)}
                                className="form-check-input"
                              />
                            </TableCell>
                            <TableCell data-cell={headCells[0].label}>
                              {row.invoiceNumber}
                            </TableCell>
                            <TableCell
                              className="text-capitalize"
                              data-cell={headCells[1].label}
                            >
                              {parseFloat(row.total).toFixed(2)}
                            </TableCell>
                            <TableCell
                              className="text-capitalize"
                              data-cell={headCells[2].label}
                            >
                              {parseFloat(row.balance).toFixed(2)}
                           
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            )}

            <p className="mb-2 txt-secondary mt-2">Select mode of Payment </p>

            <div className="payment-mode flex-wrap">
              {[...GlobalData.PAYMENT_TYPE].map((paymentType, index) => (
                <React.Fragment key={paymentType}>
                  <div className="d-flex align-items-center">
                    <input
                      id={paymentType.toLowerCase()}
                      type="radio"
                      name="Mode"
                      value={paymentType}
                      onChange={handleSelect}
                      defaultChecked={paymentType === "Cash"}
                    />
                    <label htmlFor={paymentType.toLowerCase()} className="ms-2">
                      {paymentType}
                    </label>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter
        className={`mt-2 ${
          isSuccessfulPayment ? "justify-content-center" : null
        }`}
      >
        {isSuccessfulPayment ? (
          <Button className="primary" onClick={handleSubmit}>
            Done
          </Button>
        ) : (
          <>
            <Button
              className="primary"
              isLoading={isAddPaymentApiLoading}
              buttonTitle={isAddPaymentApiLoading ? "Loading..." : "Pay"}
              disabled={
                !isUseAvailableBalance && !payableAmount
                  ? true
                  : isAddPaymentApiLoading
              }

              onClick={() => {
                if (
                  selectedPendingInvoiceList &&
                  selectedPendingInvoiceList.length > 0
                ) {
                  toggleConfirmationModal();
                } else {
                  addPaymentHandler();
                }
              }}
            ></Button>
            <Button
              className="secondary outline"
              type="button"
              disabled={isAddPaymentApiLoading}
              onClick={() => {
                props.onHide();
                setIsUseAvailableBalance(false);
                setPaymentMessage("");
                setPendingInvoiceList([]);
                setSelectedPendingInvoiceCost(0);
                setSelectedPendingInvoiceList([]);
                setPendingInvoices([]);
                setPayableAmount("");
                setTotalPendingAmount(0);
                setRemainingAvailableBalance(0);
                setConfirmationModal(false);
              }}
            >
              Cancel
            </Button>
          </>
        )}
      </ModalFooter>

      <ConfirmationModal
        show={confirmationModal}
        onHide={toggleConfirmationModal}
        text={
          "Please note, The amount will first be used to pay the selected pending invoices, and  remaining amount will be used to pay the current invoice"
        }
        btn1Text="Proceed"
        btn2Text="Cancel"
        isPaymentConfirmationModal={true}
        btn1Handler={addPaymentHandler}
        isLoading={isAddPaymentApiLoading}
        showInput={false}
      />
    </Modal>
  );
}
